export default __webpack_public_path__ + "static/media/pro-elevate-pyl-banner-1.6f617c2c.jpg";